import React from 'react'
import { Link } from 'react-router-dom'

const SubHeader = (props) => {
    return (
        <>
            <section className="subheader-bannerbg">
                <div className="container">
                    <h2 className='mt-5'>{props.message}</h2>
                    <Link className='header-link text-light me-0' to='/'>Home</Link><span className='px-3'>|</span><span>{props.message}</span>
                </div>
            </section>

        </>
    )
}

export default SubHeader
